<template>
    <form @submit.prevent="onSubmit">
        <dynamic-input type="text" :label="dynamicInput.label" v-model="dynamicInput.value" :isRequired="true"></dynamic-input>
        <button type="submit" class="btn btn-primary btn-lg">Submit</button>
    </form>
</template>

<script>
    import DynamicInput from '../../components/input/DynamicInput';
    import { DynamicInputModel } from '../../models/models';

    export default {
        components: {
            DynamicInput
        },
        data() {
            return {
                dynamicInput: new DynamicInputModel({
                    value: 'Test Initial Value',
                    label: 'Test Label'
                })
            }
        },
        methods: {
            onSubmit() {
                this.$validator.validateAll().then(result => {

                });
            }
        },
        watch: {
            inputValue: {
                handler(newVal, oldVal) {
                    console.log(this.inputValue);
                }
            }
        }
    }
</script>
